import { useContext } from 'react';

import { TranscriptContext, TranscriptContextValue } from '../store';

/**
 * Hook to get the transcript context
 * @returns {{ state: TranscriptContextState, dispatch: TranscriptContextDispatcher }}
 */
export const useTranscriptContext = (): TranscriptContextValue => {
  return useContext(TranscriptContext);
};
